// Only control characters inside a string literal are escaped. A pretty-printed
// document indents with raw newlines and tabs between tokens; escaping those
// would leave them inside no string at all and produce invalid JSON, so a plain
// regex over the whole document does not work here.
const escapeControlCharsInStrings = (jsonString: string): string => {
  let result = '';
  let inString = false;
  let escaped = false;

  for (const char of jsonString) {
    if (escaped) {
      result += char;
      escaped = false;
    } else if (inString && char === '\\') {
      result += char;
      escaped = true;
    } else if (char === '"') {
      inString = !inString;
      result += char;
    } else if (inString && char < ' ') {
      result += '\\u' + char.charCodeAt(0).toString(16).padStart(4, '0');
    } else {
      result += char;
    }
  }

  return result;
}

// Answer blobs reach us with raw tabs and newlines inside their string literals
// when whoever wrote them did not escape control characters. JSON rejects the
// whole document over one stray tab, which silently loses every answer on a
// form, so retry with those characters escaped. Round-trips the original values.
export const parseJsonRecovering = (jsonString: string): any => {
  try {
    return JSON.parse(jsonString);
  } catch {
    return JSON.parse(escapeControlCharsInStrings(jsonString));
  }
}

export const canParseJson = (jsonString: string): boolean => {
  try {
    parseJsonRecovering(jsonString);
    return true;
  } catch {
    return false;
  }
}
